import { gql } from "@apollo/client";

const GET_TRAMO_DETALLE = gql`
query tramoById(
    $idTramo: Int!
) {
    tramoById(idTramo: $idTramo)
    {
        idHonorarioProfesionalAjuste
        idDelegacion
        descripcion
        idTipoProfesional
        valor
        activo
        fechaExpira
    }
}`;

export default GET_TRAMO_DETALLE;

export const adaptTramo = (tramo) => {
  return {
    id: tramo?.idHonorarioProfesionalAjuste,
    idDelegacion: tramo?.idDelegacion,
    descripcion: tramo?.descripcion,
    idTipoProfesional: tramo?.idTipoProfesional,
    valor: tramo?.valor,
    activo: tramo?.activo,
    fechaExpira: tramo?.fechaExpira
  };
};